import React, { useEffect, useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import $ from "jquery";
import Services from "../../services/services";
import Recent_Jobs from "../Jobs/Recent_Jobs";
import { useNavigate } from "react-router-dom";
import Hiring from "../Jobs/Hiring";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";

// 👇 This is the actual form that uses reCAPTCHA
const ContactFormInner = () => {
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [contactUsContent, setContactusContent] = useState([]);
  const [apiError, setApiError] = useState("");
  //const staticData = require(`../../constants/${process.env.REACT_APP_STATIC_FOLDER}/static-data.json`);
  const staticData = require('../../constants/'+process.env.React_App_Static_Folder+'/static-data.json');
  const COMMENT_MAX = 2000; // Safe for MySQL TEXT field
  const nameRegex = /^[A-Za-z ]+$/;
  const [commentLength, setCommentLength] = useState(0);

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all",
    mode: "onBlur"
  });

  useEffect(() => {
    $("#yourphone2").usPhoneFormat();
    getPageInfo();
  }, []);

  const getPageInfo = () => {
    Services.getCMSStaticPageContentByEndPoint(staticData.static_pages.contact_us).then((res) => {
      if (res.data) {
        setContactusContent(res.data.content.rendered);
      }
    });
  };

  const submitValue2 = async () => {
    try {
      if (!executeRecaptcha) {
        alert("reCAPTCHA not yet available. Please try again.");
        return;
      }

      const token = await executeRecaptcha("contact_form_submit");
      console.log("reCAPTCHA token:", token);

      const requestObject = {
        firstName: $("#firstName").val(),
        lastName: $("#lastName").val(),
        phone: $("#yourphone2").val(),
        siteId: process.env.REACT_APP_SITE_ID_VAL,        
        email: $("#email").val(),       
        comment: $("#comment").val(),
        captchaToken: token,        
        
      };
      console.log(JSON.stringify(requestObject))

      
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestObject)
      };

      Services.contactNotification(requestOptions).then((res) => {
        console.log("Response:", res);
        navigate("/thankyou");
      });


      
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    }
  };




  const submitValue = async () => {
  try {
    setApiError(""); // reset error

    if (!executeRecaptcha) {
      alert("reCAPTCHA not yet available. Please try again.");
      return;
    }

    const token = await executeRecaptcha("contact_form_submit");
    console.log("reCAPTCHA token:", token);

    const requestObject = {
      firstName: $("#firstName").val(),
      lastName: $("#lastName").val(),
      phone: $("#yourphone2").val(),
      siteId: process.env.REACT_APP_SITE_ID_VAL,
      email: $("#email").val(),
      comment: $("#comment").val(),
      captchaToken: token,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestObject),
    };

    Services.contactNotification(requestOptions).then((res) => {
      console.log("Response:", res);

      // SUCCESS  ✅
      if (
        res &&
        (res.success === "true" || res.code === "200")
      ) {
        navigate("/thankyou");
      } 
      // FAILURE  ❌
      else {
        setApiError(
          res && res.message
            ? res.message
            : "Something went wrong. Please try again later."
        );
      }
    });

  } catch (error) {
    console.error("Error submitting form:", error);
    setApiError("Something went wrong. Please try again.");
  }
};





  return (
    <main className="empr-directory-main">
      <div className="main-bgpatten"></div>
      <section className="headtitle-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item headtitle">
                    <a href="#">Contact Us</a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="company-detail-wrap py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="white-bg px-5 pt-5 pb-4">
                <div dangerouslySetInnerHTML={{ __html: contactUsContent }} />

                <form onSubmit={handleSubmit(submitValue)}>
                  <div className="row resume-wrap">
                    <div className="col-12 my-4">
                      <h2 className="headtitle">Send Us a Message</h2>
                    </div>

                    <div className="col-lg-6 mb-4">
                      <label className="form-label">
                        First Name<span className="red-text">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        {...register("FirstName", {
                          required: "First name is required.",
                          pattern: {
                            value: nameRegex,
                            message: "Only letters are allowed. Numbers are not permitted."
                          }
                        })}
                      />
                      <ErrorMessage errors={errors} name="FirstName" render={({ message }) => <p className="error">{message}</p>} />
                    </div>

                    <div className="col-lg-6 mb-4">
                      <label className="form-label">
                        Last Name<span className="red-text">*</span>
                      </label>
                      
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        {...register("LastName", {
                          required: "Last name is required.",
                          pattern: {
                            value: nameRegex,
                            message: "Only letters are allowed. Numbers are not permitted."
                          }
                        })}
                      />
                      <ErrorMessage errors={errors} name="LastName" render={({ message }) => <p className="error">{message}</p>} />

                    </div>

                    <div className="col-lg-6 mb-4">
                      <label className="form-label">
                        Email<span className="red-text">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        {...register("Email", {
                          required: "Email is required.",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address"
                          }
                        })}
                      />
                      <ErrorMessage errors={errors} name="Email" render={({ message }) => <p className="error">{message}</p>} />
                    </div>

                    <div className="col-lg-6 mb-4">
                      <label className="form-label">
                        Phone <small>XXX-XXX-XXXX Format</small>
                      </label>
                      <input type="text" className="form-control" id="yourphone2" maxLength="14" />
                    </div>

                    <div className="col-lg-12 mb-4">
                      <label className="form-label">
                        Your Question or Comment<span className="red-text">*</span>
                      </label>
                      <textarea
                        className="form-control textarea"
                        id="comment"
                        maxLength={COMMENT_MAX}
                        {...register("comment", {
                          required: "Please enter a comment",
                          maxLength: {
                            value: COMMENT_MAX,
                            message: `Comment cannot exceed ${COMMENT_MAX} characters.`
                          }
                        })}
                        onChange={(e) => setCommentLength(e.target.value.length)}
                      ></textarea>

                      <div style={{ fontSize: "12px", marginTop: "4px", color: "#666" }}>
                        {commentLength}/{COMMENT_MAX} characters
                      </div>

                      <ErrorMessage errors={errors} name="comment" render={({ message }) => (
                        <p className="error">{message}</p>
                      )} />

                    </div>

                  
                    <div>
                      <button type="submit" className="reg-button">
                        Send
                      </button>
                    </div>
                      {apiError && (
                      <p className="error" style={{ color: "red", marginTop: "10px" }}>
                        {apiError}
                      </p>
                    )}
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-4">
              <Recent_Jobs />
            </div>
          </div>
        </div>
      </section>
      <Hiring />
    </main>
  );
};

// 👇 Outer wrapper — only Contact Us loads reCAPTCHA
const Contactus = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <ContactFormInner />
    </GoogleReCaptchaProvider>
  );
};

export default Contactus;
